import { faImage, faVideo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

import { DARK_BLUE } from "theme/colors";

interface Props {
  fontSize?: string;
  isLoading?: boolean;
  type: "image" | "video";
}

export const Placeholder: React.FC<Props> = ({ fontSize, isLoading, type }) => {
  const getIcon = () => {
    const style = { fontSize: fontSize || "24px", color: DARK_BLUE[30] };

    if (type === "image") {
      return <FontAwesomeIcon icon={faImage} style={style} />;
    }
    if (type === "video") {
      return <FontAwesomeIcon icon={faVideo} style={style} />;
    }
    return null;
  };

  return <Container className={`${isLoading ? "loading" : ""}`}>{getIcon()}</Container>;
};

const Container = styled.div`
  @keyframes wave {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  &.loading {
    position: relative;
    display: inline-block;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        90deg,
        rgba(240, 240, 240, 0) 0%,
        rgba(255, 255, 255, 0.8) 50%,
        rgba(240, 240, 240, 0) 100%
      );
      background-size: 200% 100%;
      animation: wave 2.5s linear infinite;
      border-radius: 4px;
      pointer-events: none;
    }
  }
`;
